import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import selectors from 'selectors'
import locationGroupActions from 'actions/locationGroups'
import locationActions from 'actions/locations'
import operatorActions from 'actions/operators'
import userActions from 'actions/users'
import assetCategoryActions from 'actions/assetCategories'
import jobActions from 'actions/jobs'
import Component from 'components/Assets/Filter'

const mapStateToProps = (state, props) => ({
  ...createAuthStateToProps(state, props),
  locationGroups: selectors.locationGroups.selectOptions(state),
  locations: selectors.locations.selectOptions(state),
  operators: selectors.operators.selectOptions(state, { itemsOnly: false }),
  users: selectors.users.selectOptions(state),
  assetCategories: selectors.assetCategories.selectOptions(state),
  jobs: selectors.jobs.selectOptions(state, { itemsOnly: false }),
})

const mapDispatchToProps = (dispatch, props) => ({
  getLocationGroups: (params) => dispatch(locationGroupActions.getOptions(params)),
  getLocations: (params) =>
    dispatch(locationActions.getOptions({ ...params, active: 'All', locationVendingTypes: ['NonVending'] })),
  getOperators: (params) =>
    dispatch(
      operatorActions.getOptions({
        active: 'All',
        pageIndex: 1,
        pageSize: 100,
        ...params,
      }),
    ),
  getUsers: (params) => dispatch(userActions.getOptions({ ...params, active: 'All' })),
  getAssetCategories: (params) => dispatch(assetCategoryActions.getOptions(params)),
  getJobs: (params) =>
    dispatch(
      jobActions.getOptions({
        pageIndex: 1,
        pageSize: 100,
        ...params,
        active: 'All',
      }),
    ),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)
